import styled from '@emotion/styled';
import { StoryToPlayFragment } from '@graphql/generated/graphql';
import StrapiImage from '@lib/image/strapiImage';
import { getStrapiAssetUrl } from '@lib/strapi';
import { HStack, VStack } from '@lib/uikit';
import { FC } from 'react';

import { SanitizedStoryPage } from '../../types';
import { ExitButton } from '../buttons/ExitButton';
import ProgressArray from '../progress/ProgressArray';

interface Props {
    story: StoryToPlayFragment;
    storyPage: SanitizedStoryPage;
    withExit: boolean;
}

const Backdrop = styled.div`
    width: 100%;
    background: ${({ theme }) => theme.gradients.backdropUp};
    padding-block-end: ${({ theme }) => theme.spacing.lg};
`;

const PageTitle = styled.h1`
    font: ${({ theme }) => theme.fonts.body};
    color: ${({ theme }) => theme.palette.common.white};
`;

const PageSubtitle = styled.h2`
    font: ${({ theme }) => theme.fonts.caption};
    color: ${({ theme }) => theme.palette.common.white};
`;

const PreviewImage = styled(StrapiImage)`
    width: 2rem;
    height: 2rem;
    border-radius: 50%;
    margin-top: ${({ theme }) => theme.spacing.xxs};
    object-fit: cover;
`;

export const StoryHeader: FC<Props> = ({ story, storyPage, withExit }) => {
    const title = storyPage.title;
    const subtitle = storyPage.subtitle;
    const previewImage = story.PreviewImage;

    return (
        <Backdrop>
            <ProgressArray />
            <HStack marginTop='sm' justifyContent='space-between'>
                <HStack paddingInline='sm' spacing='xs' alignItems='stretch'>
                    {previewImage && (
                        <PreviewImage
                            sizes='2rem'
                            formats={previewImage.formats}
                            src={getStrapiAssetUrl(previewImage)}
                            alt={previewImage.alternativeText || story.Title}
                        />
                    )}
                    <VStack spacing='xxxs'>
                        {title && <PageTitle>{title}</PageTitle>}
                        {subtitle && <PageSubtitle>{subtitle}</PageSubtitle>}
                    </VStack>
                </HStack>
                {withExit && <ExitButton />}
            </HStack>
        </Backdrop>
    );
};
